import React from 'react';
import PaymentTrackingPage from '../shared/PaymentTrackingPage';

export default function PaymentInfo() {
  return (
    <PaymentTrackingPage
      title="Payment Tracking"
      subtitle="Party-centric accounting, payment-based active orders (All Salespersons)"
    />
  );
}
